/**
 * URL parameter keys used across the application for state management
 * These constants ensure consistency and make updates easier
 *
 * ! Important: The URL keys MUST be unique and cannot be shared between different filters.
 *
 */

export const CommonURLKey = {
  // Pagination & sorting
  PAGE: "p",
  PER_PAGE: "pp",
  SORT_BY: "sb",
  SORT_ORDER: "so",

  // Selection
  SELECTED_FEATURE: "sf",

  // Filters - Common
  PROJECT_IDS: "prid",
  COMPANY_IDS: "cid",
  PARTNER_IDS: "pid",
  DMA_IDS: "dmas"
} as const;

export const WaypointURLKey = {
  // Search
  SEARCH: "w.s",

  // Filters
  CREATED_FROM: "w.cf",
  CREATED_TO: "w.ct",
  UPDATED_FROM: "w.uf",
  UPDATED_TO: "w.ut",
  STATUS_IDS: "w.sid",
  PREDICTED_SIZES: "w.ps",
  PREDICTED_LEAK_TYPE_IDS: "w.plt",
  JOB_TYPE_CODES: "w.jtc",
  LAST_SCHEDULED_ENGINEER_IDS: "w.lse",
  LAST_ACTION_USER_IDS: "w.lau"
} as const;

export const SessionURLKey = {
  // Search
  SEARCH: "s.s",

  // Filters
  CREATED_FROM: "s.cf",
  CREATED_TO: "s.ct",
  ENDED_FROM: "s.enf",
  ENDED_TO: "s.ent",
  EXPECTED_FINISH_FROM: "s.exf",
  EXPECTED_FINISH_TO: "s.ext",
  STARTED_FROM: "s.sf",
  STARTED_TO: "s.st",
  UPDATED_FROM: "s.uf",
  UPDATED_TO: "s.ut",
  COLLECTED_BY_IDS: "s.cbi",
  DEPLOYED_BY_IDS: "s.dbi",
  FIDO_RESULTS: "s.fi",
  PREDICTED_SIZES: "s.ps",
  RELAY_CONNECTED: "s.rc",
  SESSION_IDS: "s.sid",
  SESSION_TYPES: "s.sty",
  STATUS_IDS: "s.sti"
} as const;

export const RelayURLKey = {
  // Search
  SEARCH: "r.s",

  // Filters
  LAST_UPDATE_FROM: "r.luf",
  LAST_UPDATE_TO: "r.lut",
  LAST_CONTACT_FROM: "r.lcf",
  LAST_CONTACT_TO: "r.lct",

  RELAY_IDS: "r.rid",
  RELAY_STATUSES: "r.rs"
} as const;

export const SensorURLKey = {
  // Search
  SEARCH: "sn.s",

  // Filters - Date
  SESSION_STARTED_FROM: "sn.ssf",
  SESSION_STARTED_TO: "sn.sst",
  SESSION_ENDED_FROM: "sn.sef",
  SESSION_ENDED_TO: "sn.set",

  // Filters - IDs
  SENSOR_IDS: "sn.sid",
  SESSION_IDS: "sn.seid",
  SESSION_TYPES: "sn.sty",
  DEPLOYED_BY_IDS: "sn.dbi",
  COLLECTED_BY_IDS: "sn.cbi"
} as const;
